import {addDoc, updateDoc, deleteDoc, getDoc, CollectionReference, DocumentReference} from 'firebase/firestore';
import {getDocRef, Fields, getCollection, ServerTimestamp} from './firestore.db';

const getJobProperties = (event, options) => {
  switch (event) {
    case "*-5-*-*-*-*": {
      return {
        description: "Every 5 minutes",
        source: "calendar",
        icon: "ClockIcon",
        event,
      };
    }
    case "0-*-*-*-*": {
      return {
        description: "Every hour",
        source: "calendar",
        icon: "ClockIcon",
        event,
      };
    }
    case "0-0-*-*-*": {
      return {
        description: "Every day at midnight",
        source: "calendar",
        icon: "ClockIcon",
        event,
      };
    }
    case "answered": {
      return {
        description: "An event triggered by a phone call",
        source: "phone",
        icon: "PhoneCallIcon",
        event,
      };
    }
    case "missed": {
      return {
        description: "An event triggered by a missed phone call",
        source: "phone",
        icon: "PhoneCallIcon",
        event,
      }
    }
    case "receive": {
      return {
        description: "An event triggered by a received text message",
        source: "sms",
        icon: "MessageOutlined",
        event,
      };
    }
    case "send": {
      return {
        description: "An event triggered by a sent text message",
        source: "sms",
        icon: "MessageOutlined",
        event,
      };
    }
    case "login": {
      return {
        description: "An event triggered when you login",
        source: "auth",
        icon: "LockIcon",
        event,
      }
    }
    case "connect": {
      return {
        description: 'An event triggered when you connect a tool',
        source: 'auth',
        icon: 'LockIcon',
        event,
      }
    }
    case "onDemand": {
      return {
        source: "user",
        description: 'An event triggered on demand',
        icon: 'LockIcon',
        event,
      }
    }
    case "onDocumentCreated": {
      return {
        description: "An event triggered when a document is added to the collection",
        source: options.collectionRef.path,
        icon: "DatabaseIcon",
        event,
      }
    }
    case "onDocumentDeleted": {
      return {
        description: "An event triggered when a document is deleted from the collection",
        source: options.collectionRef.path,
        icon: "DatabaseIcon",
        event,
      }
    }
    default: {
      throw new Error("Unimplemented event type");
    }
  }
}

/**
 * @summary Add a collection job to an app
 * @param {string} basePath
 * @param {string} type
 * @param {DocumentReference} workflowRef
 * @param {models.Workflow.Data} workflow
 * @param {models.WorkflowJob.CollectionTriggerEvent} event
 * @param {CollectionReference} [collectionRef]
 * @returns {Promise<DocumentReference>}
 */
export function addJob(basePath, type, workflowRef, workflow, event, collectionRef) {
  /** @type {models.WorkflowJob.Data} */
  const data = {
    ...getJobProperties(event, {collectionRef}),
    workflow,
    workflowPath: workflowRef.path,
    type,
    paused: true,
  };

  return addDoc(
    getCollection([basePath, "jobs"].join("/")),
    {
      ...data,
      date: ServerTimestamp(),
    });
}

export function updateJob(jobRef, updates) {
  if (!jobRef.path.includes("/jobs/")) {
    return new Error('Job ref must be a valid path');
  }
  return updateDoc(
    jobRef, {
      ...updates,
      date: ServerTimestamp(),
    })
}

export function removeJob(jobRef) {
  if (!jobRef.path.includes("/jobs/")) {
    return new Error('Job ref must be a valid path');
  }
  return getDoc(jobRef)
  .then((jobDoc) =>
    getDocRef(jobDoc.get("workflowPath")))
  .then((jobRef) =>
    updateDoc(jobRef, {
      jobPaths: Fields.arrayRemove(jobRef.path),
      date: ServerTimestamp(),
    }))
  .then(() => deleteDoc(jobRef))
}
